import UiState from '../../constants/ui-state';

class UiStateStore extends EventEmitter {
    constructor() {
        super();

        this.CHANGE_EVENT = 'UI_STATE_CHANGE_EVENT';

        this._model = {};
    }

    registerComponent(componentId) {
        this._model[`c${componentId}`] = {
            bubble: {
                bubblePlaceholder: null,
                isBubbleRendered: false,
                isBubbleVisible: false,
                position: {
                    top: 0,
                    left: 0,
                    overflow: 0,
                    width: 385
                }
            },
            form: {
                uiState: UiState.initial,
                formPlaceholder: null,
                showProductInformation: false,
                formVariants: [],
                localizationOverrides: []
            }
        };
    }

    getModel(componentId) {

        if (componentId === undefined || componentId === null){
            throw new Error('componentId is missing');
        }

        return this._model[`c${componentId}`];
    }

    addChangeListener(callback) {
        this.on(this.CHANGE_EVENT, callback);
    }

    removeChangeListener(callback) {
        this.removeListener(this.CHANGE_EVENT, callback);
    }

    update(componentId, updateFn) {
        if (updateFn) {
            updateFn(this.getModel(componentId));
        }

        this.emit(this.CHANGE_EVENT);
    }
}

let uiStateStore = new UiStateStore();
uiStateStore.setMaxListeners(1000000);
export default uiStateStore;



/** WEBPACK FOOTER **
 ** ./src/logic/stores/ui-state-store.js
 **/